import { combineReducers } from 'redux';

import assignees from './assignees/reducers';
import sections from './sections/reducers';
import projects from './projects/reducers';

export default combineReducers({
  assignees,
  sections,
  projects,
});
